<template>
  <div v-loading="loading" class="newBox">
    <div v-show="!loading&&!isWxBind" class="loginboxs">
      <div style="text-align: center;overflow: hidden;position: absolute;top: 40px;left: 130px;cursor: pointer">
        <img :src="logo" alt="" @click="gohome">
      </div>
      <div style="text-align: center;font-size: 15px;padding-top: 150px;overflow: hidden;">
        绑定手机号
      </div>
      <p style="color: #69513c;text-align: center;margin-top: 20px">
        <span style="display: inline-block;width: 300px;margin-bottom: 30px;">您已通过  微信账号   登录成功，请绑定手机号，以便登录更方便！</span>
      </p>
      <el-form v-show="!newuser" ref="ruleForm" :model="ruleForm" status-icon :rules="rules" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="phoneNumber" :error="errors.phone">
          <el-input v-model="ruleForm.phoneNumber" auto-complete="off" placeholder="请输入手机号 ">
            <i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="user" /></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="checkCode" :error="errors.code">
          <el-input v-model="ruleForm.checkCode" type="checkCode" auto-complete="off" placeholder="请确验证码 " class="checkbox">
            <i slot="prefix" class="el-icon-user ico"><svg-icon icon-class="pwd" /></i>
          </el-input>
          <div v-show="isVcodeBtn" class="getVcodeBtn" @click="getVcode">
            获取验证码
          </div>
          <div v-show="!isVcodeBtn" class="getVcodeBtn num">
            重新发送 <span>({{ count }})</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="denglubtn" @click="submitForm('ruleForm')">
            绑定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="!loading&&isWxBind">
      <p style="text-align: center;padding-top: 30vh;font-size: 18px;color: #fff">该微信已经绑定 <a href="/login" style="font-size:18px;color: #ed4040">去登录</a></p>
    </div>
  </div>
</template>
<script>
import { wxBindingCallback, userIsBinding, getPhoneIs, addWxBindingUser } from '@/api/login.js'
import { checkRegister, getVcode, cheakLogin } from '@/api/api.js'
// import topHead from '@/views/components/header.vue'
export default {
  // components: { topHead },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '',
      mateDesc: metaStr
    }
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var checkvcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }
      setTimeout(() => {
        if (!(/^1[34578]\d{9}$/.test(value))) {
          callback(new Error('格式错误，请输入正确的手机号'))
        } else {
          callback()
        }
      }, 200)
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value + '' !== this.ruleForm_new.password + '') {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      isWxBind: true,
      newuser: false,
      errors: {
        code: '',
        phone: ''
      },
      dataKey: '',
      openid: '',
      logo: require('@/static/chinagen_logo.png'),
      loading: true,
      loginIMG: require('@/static/loginIMG_new.png'),
      show: false,
      isVcodeBtn: true,
      count: 60,
      ruleForm: {
        phoneNumber: '',
        checkCode: ''
      },
      ruleForm_new: {
        checkPass: '',
        password: ''
      },
      rules: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'change' }
        ]
      },
      rules_new: {
        phoneNumber: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { validator: checkpass, trigger: 'blur' }
        ],
        checkCode: [
          { validator: checkvcode, trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    if (this.$route.query.code) {
      wxBindingCallback(this.$route.query).then(res => {
        if (res.data.isState == 4) {
          this.loading = false
          this.isWxBind = false
          this.dataKey = res.data.jmKey
        // 【0-成功， 1-稍后重试， 2-该微信已绑定， 3-用户未登陆， 4-需要输入手机号【跳转前端控制】，】
        }
        if (res.data.isState == 2) {
          this.isWxBind = true
          this.loading = false
        }
        if (res.data.isState == 0) {
          this.setloca('userid', res.data.fwUserId, 7200)
          this.$router.push({ path: '/home' })
        }
      })
    }
  },
  methods: {
    gohome() {
      this.$router.push({ path: '/home' })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs.ruleForm.clearValidate()
          var obj = {}
          obj.phone = this.ruleForm.phoneNumber
          obj.code = this.ruleForm.checkCode
          obj.dataKey = this.dataKey
          getPhoneIs({ phone: this.ruleForm.phoneNumber }).then(res => {
            if (res.data) {
              addWxBindingUser(obj).then(res => {
                if (res.data.isState == 4) {
                  this.errors = { code: '验证码错误' }
                }
                if (res.data.isState == 1 || res.data.isState == 2 || res.data.isState == 2) {
                  this.errors = { code: '异常，请重新登录后再试' }
                  // this.$router.push({ path: '/login' })
                }
                if (res.data.isState == 0) {
                  this.setloca('userid', res.data.fwUserId, 7200)
                  this.$router.push({ path: '/home' })
                }
              })
            } else {
              this.errors = { code: '该手机号已绑定' }
            }
          })
        }
      })
    },
    getVcode() {
      this.ruleForm.checkCode = ''
      if (!(/^1[34578]\d{9}$/.test(this.ruleForm.phoneNumber))) {
        this.$message({
          message: '请正确输入手机号',
          type: 'error',
          duration: 2000
        })
      } else {
        var obj = {}
        obj.phone = this.ruleForm.phoneNumber
        obj.codeType = '1'
        this.isVcodeBtn = false
        var timers = setInterval(() => {
          this.count--
          if (this.count <= 0) {
            this.isVcodeBtn = true
            clearInterval(timers)
          }
        }, 1000)
        getVcode(obj).then(res => {
          if (res.code == 200) {
            this.$message({
              message: '短信验证已发送',
              type: 'success',
              duration: 2000
            })
          }
        })
      }
    }
  }

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .newBox{
        width: 100%;
        position: absolute;
        background-color: #B2B2B2;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 9;
        .loginboxs{
            height: 600px;
            width: 340px;
            background-color: #fff;
            text-align: center;
            padding: 0 80px;
            margin: 50px auto;
            position: relative;
            .denglubtn{
                width: 100%;
                background-color: #69513c;
                border-color: #69513c;
                margin-top: 20px;
            }
            .checkbox{
                width: 230px;
            }
            .getVcodeBtn{
                width: 100px;
                display: inline-block;
                background-color: #ed4040;
                margin-left: 10px;
                border-radius: 5px;
                text-align: center;
                color: #ffffff;
                font-size: 12px;
                cursor: pointer;
            }
            .num{
                background-color: #fff;
                color: #a19d9e;
                cursor: not-allowed;
                span{
                    font-size: 12px;
                    color: #a19d9e;
                }
            }
        }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .bgI{
            .contentBox{
                width: 80%;
                margin: 80px auto;
                .denglubtn{
                    width: calc( 80vw - 40px )
                }
                .register{
                    margin-bottom: 20px;
                }
            }
            .checkbox{
                width: calc( 80vw - 150px);
            }
        }
    }
</style>
